module.exports = __webpack_public_path__ + "img/knight3_02.b38c0420.jpg";